var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value && _vm.displayConditionOk
    ? _c("div", { staticClass: "form-group task row" }, [
        _c("label", { staticClass: "col-12 col-form-label output-label" }, [
          _vm._v(_vm._s(_vm.label))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 my-auto output-control bg-white",
            class: _vm.cssClass
          },
          [
            _c("span", {
              staticStyle: { "white-space": "pre-wrap" },
              attrs: { name: _vm.name },
              domProps: { innerHTML: _vm._s(_vm.value) }
            })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e951e8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e951e8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Output/TextOutput.vue
// module id = 568
// module chunks = 0